import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Accordion, AccordionSummary, AccordionDetails, Typography, IconButton } from '@material-ui/core';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles({
    root: {
        border: 0,
    },
    heading: {
        fontSize: '.9rem',
        fontWeight: 600,
        opacity: '.8'
    }
});

const StyledAccordion = styled(Accordion)`
margin: 1rem 0;
border-radius: 4px;
box-shadow: 5px 5px 5px rgb(0 0 0 / 35%);
&::before {
    display: none
}
`;
const StyledHeader = styled.div`
font-weight: 600;
margin-top: 1.5rem;
margin-bottom: 1rem;
font-size: 1rem;
letter-spacing: .6px;
`
const StyledIconButton = styled(IconButton)`
margin-right: 1rem;
padding: 0;
color: #0054A8;
font-weight: 600`;

const StyledDetails = styled(AccordionDetails)`
    display: block;
    &>img {
        width: 100% !important;
    }
`

const PlusIcon = require('../../assets/img/plus.png')
const MinusIcon = require('../../assets/img/minus.png')

const Faq = ({ childFaqs }) => {
    const classes = useStyles();
    const [expandedPanel, setExpanded] = React.useState(false);

    // new
    const { childslug } = useParams();


    let questionAnswers = [];
    let title = '';
    // to set the selected question and answer
    if (childFaqs && childFaqs.length) {
        const selectedPage = childFaqs.find(({ slug }) => slug === `/${childslug}`)
        if (!selectedPage) {
            questionAnswers = childFaqs[0].questionAndAnswers;
            title = childFaqs[0].title;
        } else {
            const { questionAndAnswers, title: pageTitle } = selectedPage
            questionAnswers = questionAndAnswers;
            title = pageTitle;
        }
    }

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    }


    return (
        <div className={classes.root}>
            <StyledHeader>{title}</StyledHeader>
            {questionAnswers && questionAnswers.length ? (
                <React.Fragment>
                    {questionAnswers.map((qna, index) => (
                        <React.Fragment key={String(`${qna.question}`)}>
                            <StyledAccordion
                                // we can open one accordion at a time
                                expanded={expandedPanel === qna.question}
                                onChange={handleChange(qna.question)}>
                                <AccordionSummary
                                    aria-controls="panel1a-content"
                                    id={String(`panel_${index + 1}`)}
                                >
                                    <StyledIconButton > <img alt={expandedPanel === qna.question ? '-' : '+'}
                                        src={expandedPanel === qna.question ? MinusIcon : PlusIcon}
                                    /></StyledIconButton>
                                    <Typography className={classes.heading}>{qna.question}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <StyledDetails dangerouslySetInnerHTML={{ __html: qna.answer.html }} />
                                </AccordionDetails>
                            </StyledAccordion>
                        </React.Fragment>
                    ))}
                </React.Fragment>
            ) : (<Typography variant="h6">Please Select a topic to read Faq</Typography>)
            }
        </div >
    );
}
Faq.propType = {
    childFaqs: PropTypes.arrayOf(PropTypes.any)
}
Faq.defaulProps = {
    childFaqs: null
}
export default Faq;


// WEBPACK FOOTER //
// ./src/Components/Faq/index.js